export { AuthService } from './auth/auth.service'
export { TranslatorService } from './translator/translator.service'
